export default __webpack_public_path__ + "static/media/dynamic.3c99887b.svg";